import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Download, RefreshCw } from 'lucide-react';
import { exportToCSV } from '../../lib/admin/utils';
import OrderCard from './OrderCard';

const OrdersTab = ({ orders, loading, onRefresh, onStatusChange, onSendPaymentLink }) => (
  <div className="space-y-4" data-testid="orders-tab-content">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold text-gray-900">Wine Orders</h2>
      <div className="flex gap-2">
        <Button onClick={onRefresh} variant="outline" size="sm" data-testid="orders-refresh-btn">
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </Button>
        <Button
          onClick={() => exportToCSV(orders, 'wine-orders')}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900"
          size="sm"
          data-testid="orders-export-btn"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
    </div>

    {loading ? (
      <div className="text-center py-12">Loading...</div>
    ) : orders.length === 0 ? (
      <Card>
        <CardContent className="py-12 text-center text-gray-500" data-testid="orders-empty">
          No wine orders yet
        </CardContent>
      </Card>
    ) : (
      <div className="space-y-4">
        {orders.map((order, oIdx) => (
          <OrderCard
            key={order.orderId || `${order.email}-${order.createdAt}-${oIdx}`}
            order={order}
            onStatusChange={onStatusChange}
            onSendPaymentLink={onSendPaymentLink}
          />
        ))}
      </div>
    )}
  </div>
);

export default OrdersTab;
